import { useState } from 'react';
import { useAuth } from '../state/AuthContext.jsx';
import { useNotice } from '../state/NoticeContext.jsx';
import { Button, Card, Muted, Tag, Text, fmtDate } from '../ui.jsx';

const roleLabel = { student: 'Applicant', school_staff: 'College staff', platform_admin: 'Platform admin' };

/**
 * The account basics every role shares. The applicant's own profile lives on
 * /profile; this is only the handful of fields that come from the account
 * record itself, so a mistyped name can be corrected without an admin.
 */
export default function Account() {
  const { user, updateProfile, isSchoolStaff, isPlatformAdmin } = useAuth();
  const notice = useNotice();
  const [form, setForm] = useState({ name: user?.name || '', phone: user?.phone || '' });
  const [busy, setBusy] = useState(false);

  const set = (key) => (event) => setForm((prev) => ({ ...prev, [key]: event.target.value }));

  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await updateProfile({ name: form.name.trim(), phone: form.phone.trim() });
      notice.success('Your details are saved.');
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  const unchanged = form.name.trim() === (user?.name || '') && form.phone.trim() === (user?.phone || '');

  return (
    <>
      <h2>Your account</h2>
      <Muted>The name and number schools see on your application.</Muted>

      <Card>
        <div className="row sp" style={{ marginBottom: 4 }}>
          <div>
            <div className="mu" style={{ fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              Signed in as
            </div>
            <div style={{ fontWeight: 600 }}>{user?.email}</div>
          </div>
          <Tag tone={isPlatformAdmin ? 'mid' : isSchoolStaff ? 'ok' : ''}>
            {roleLabel[user?.role] || user?.role}
          </Tag>
        </div>
        <div className="mu" style={{ marginTop: 8, fontSize: 13 }}>
          Email {user?.emailVerified ? 'verified' : 'not verified yet'} &middot; joined {fmtDate(user?.createdAt)}
        </div>
      </Card>

      <form onSubmit={save}>
        <Card>
          <Text label="Full name" required value={form.name} onChange={set('name')} />
          <div style={{ height: 12 }} />
          <Text
            label="Phone"
            value={form.phone}
            onChange={set('phone')}
            hint="Ghana format, for example 024 123 4567. Used for deadline reminders only."
          />
          <div style={{ marginTop: 16 }}>
            <Button type="submit" busy={busy} disabled={unchanged || !form.name.trim()}>
              Save details
            </Button>
          </div>
        </Card>
      </form>
    </>
  );
}
